import { AIAgentExecutionResult } from './AIAgent'

export interface DocumentProspectingBaseFormExecutionResult {
  firstName: string | null
  lastName: string | null
  email: string | null
}

export type DocumentProspectingBaseFormExecutionResultType = AIAgentExecutionResult<DocumentProspectingBaseFormExecutionResult>

export const DocumentProspectingStep = {
  INTEGRATION: 0,
  BASE_FORM: 1,
  DETAILS_FORM: 2,
  SUCCESS: 3,
} as const

export type DocumentProspectingStep = (typeof DocumentProspectingStep)[keyof typeof DocumentProspectingStep]

export const DocumentProspectingPageType = {
  PROSPECTING_FILE_UPLOAD: 'prospecting_file_upload',
  PROSPECTING_STEPS: 'prospecting_steps',
  SUMMARY_FILE_UPLOAD: 'summary_file_upload',
  SUMMARY: 'summary',
} as const

export type DocumentProspectingPageType = (typeof DocumentProspectingPageType)[keyof typeof DocumentProspectingPageType]

export interface DocumentProspectingStepProps {
  activeStep: DocumentProspectingStep
  onActivate: (prospectingStep: DocumentProspectingStep) => void
  onComplete: () => void
}

export interface ProspectingBaseFormValues {
  firstName: string
  lastName: string
  email: string
}

interface DefaultProspectingDetailsFormValues {
  type: 'default'
  data: Record<string, unknown>
}

export interface SegmentedProspectingDetailsFormValues {
  type: 'segmented'
  data: Record<string, Record<string, unknown>>
}

export type ProspectingDetailsFormValues = DefaultProspectingDetailsFormValues | SegmentedProspectingDetailsFormValues

type DefaultDocumentProspectingDetailsFormSchemaType = Record<string, unknown>

interface DocumentProspectingDetailsFormSchemaPanel {
  name: string
  description?: string
  schema: DefaultDocumentProspectingDetailsFormSchemaType
}

export type SegmentedDocumentProspectingDetailsFormSchemaType = Record<string, DocumentProspectingDetailsFormSchemaPanel>

type DefaultDocumentProspectingDetailsFormValuesType = Record<string, unknown>

interface DocumentProspectingDetailsFormValuesPanel {
  name: string
  description?: string
  values: DefaultDocumentProspectingDetailsFormValuesType
}

export type SegmentedDocumentProspectingDetailsFormValuesType = Record<string, DocumentProspectingDetailsFormValuesPanel>

interface DefaultDocumentProspectingDetailsFormProps {
  type: 'default'
  schema: DefaultDocumentProspectingDetailsFormSchemaType
  previousValues: DefaultDocumentProspectingDetailsFormValuesType
}

export interface SegmentedDocumentProspectingDetailsFormProps {
  type: 'segmented'
  schema: SegmentedDocumentProspectingDetailsFormSchemaType
  previousValues: SegmentedDocumentProspectingDetailsFormValuesType
}

export type DocumentProspectingDetailsFormProps = DefaultDocumentProspectingDetailsFormProps | SegmentedDocumentProspectingDetailsFormProps
